export default "__VITE_ASSET__Dxp07cVv__"